<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">

          <!-- Título da tela -->
          <basic-toolbar :title="'Editar Atividade'"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>

                <!-- Nome da atividade / Nome e descrição sucinta da atividade -->
                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-textarea
                      :label="atividade.detalhamento !== null && atividade.detalhamento !== '' ? 'Nome da atividade' : 'Nome e descrição sucinta da atividade'"
                      v-model="atividade.descricao"
                      rows="1"
                      auto-grow
                      required
                      :rules="nomeAtividadeRules"
                      counter="250"
                      max-height="400"
                    ></v-textarea>
                  </v-flex>
                </v-layout>

                <!-- Descrição sucinta da atividade -->
                <v-layout v-if="atividade.detalhamento !== null && atividade.detalhamento !== ''" row wrap justify-space-between>
                  <v-flex xs12>
                    <c-textarea
                      label="Descrição sucinta da atividade"
                      v-model="atividade.detalhamento"
                      required
                      :rules="assuntoSummaryRules"
                      :rows="3"
                      :auto-grow="true"
                      multi-line
                      counter="200"
                     >
                    </c-textarea>
                  </v-flex>
                </v-layout>

                <!-- Principal objetivo específico ao qual esta atividade está vinculada -->
                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-select
                      label='Principal objetivo específico ao qual esta atividade está vinculada'
                      :items="objetivosEspecificosTopicos"
                      v-model="atividade.objetivoEspecifico"
                      item-text="nome"
                      item-value="nome"
                      prepend-icon="dashboard"
                      :rules="obrigatorio"
                      autocomplete
                    >
                      <template slot="no-data">
                        Não existem objetivos específicos cadastrados.
                      </template>
                    </v-select>
                  </v-flex>
                </v-layout>

                <!-- Situação da atividade -->
                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-select
                      label='Situação da atividade'
                      :items="listaSituacaoAtividade"
                      v-model="atividade.situacaoAtividade"
                      item-text="descricao"
                      item-value="item"
                      prepend-icon="dashboard"
                      :rules="obrigatorio"
                      autocomplete
                      return-object
                    ></v-select>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>

                  <!-- Data de início prevista -->
                  <v-flex xs11 sm5>
                    <v-text-field
                      label="Data de início prevista"
                      v-model="atividade.dtInicioPrevisto"
                      :rules="obrigatorio"
                      type="date"
                      >
                    </v-text-field>
                  </v-flex>

                  <v-spacer></v-spacer>

                  <!-- Data de conclusão prevista -->
                  <v-flex xs11 sm5>
                    <v-text-field
                      label="Data de conclusão prevista"
                      v-model="atividade.dtFimPrevisto"
                      :rules="obrigatorio"
                      type="date"
                      >
                    </v-text-field>
                  </v-flex>

                </v-layout>

                <!-- Apenas nas situações "Em andamento" ou "Cumprida" -->
                <v-layout row wrap v-if="atividade.situacaoAtividade !== null && (atividade.situacaoAtividade.item === 2 || atividade.situacaoAtividade.item === 3)">

                  <!-- Data de início efetiva -->
                  <v-flex xs11 sm5 v-if="atividade.situacaoAtividade !== null && (atividade.situacaoAtividade.item === 2 || atividade.situacaoAtividade.item === 3)">
                    <v-text-field
                      label="Data de início efetiva"
                      v-model="atividade.dtInicioEfetivo"
                      :rules="atividade.situacaoAtividade !== null && (atividade.situacaoAtividade.item === 2 || atividade.situacaoAtividade.item === 3) ? obrigatorio : null"  
                      type="date"                    
                      >
                    </v-text-field>
                  </v-flex>

                  <v-spacer></v-spacer>

                  <!-- Data de conclusão efetiva -->
                  <v-flex xs11 sm5 v-if="atividade.situacaoAtividade !== null && atividade.situacaoAtividade.item === 3">
                    <v-text-field
                      label="Data de conclusão efetiva"
                      v-model="atividade.dtFimEfetivo"
                      :rules="atividade.situacaoAtividade !== null && atividade.situacaoAtividade.item === 3 ? obrigatorio : null"
                      type="date"
                      >
                    </v-text-field>
                  </v-flex>

                </v-layout>

                <!-- Resultados -->
                <v-layout row wrap justify-space-between v-if="atividade.situacaoAtividade !== null && (atividade.situacaoAtividade.item === 2 || atividade.situacaoAtividade.item === 3)">
                  <v-flex xs12>
                    <v-textarea
                      label='Resultados'
                      v-model="atividade.resultados"
                      rows="3"
                      auto-grow
                      :rules="resultadosRules"
                      counter="1000">
                    </v-textarea>
                  </v-flex>
                </v-layout>

              </v-container>
            </v-form>
            <v-divider></v-divider>
            <v-card-actions>

              <!-- Cancelar -->
              <v-btn color="primary" text @click="cancelar">Cancelar</v-btn>

              <v-spacer></v-spacer>

              <!-- Salvar -->
              <v-btn color="primary" text @click="editarAtividade" :disabled="!formularioValido">Salvar</v-btn>

            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import DataMenu from '@/components/c-date-menu'
  import DataDialog from '@/components/c-date-dialog'
  import TextArea from '@/components/c-textarea'
  import projetos from '@/utils/projetos'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjeto', 'idAtividade'],
    data: () => ({
      formularioValido: false,
      atividade: {},
      projeto: {
        titulo: '',
        dataInicio: '',
        dataConclusao: '',
        observacoes: '',
        situacao: {},
        tipoPublico: {},
        tipoEvento: {}
      },
      extensao: {},
      objetivosEspecificosTopicos: [],
      listaSituacaoAtividade: null,
      listaSituacaoAtividadeNaoPreenchida: [
        {item: 1, descricao: 'Não iniciada'},
        {item: 2, descricao: 'Em andamento'},
        {item: 3, descricao: 'Cumprida'}
      ],
      listaSituacaoAtividadeNaoIniciada: [
        {item: 1, descricao: 'Não iniciada'},
        {item: 2, descricao: 'Em andamento'},
        {item: 3, descricao: 'Cumprida'},
        {item: 4, descricao: 'Cancelada'}
      ],
      listaSituacaoAtividadeEmAndamento: [
        {item: 2, descricao: 'Em andamento'},
        {item: 3, descricao: 'Cumprida'},
        {item: 4, descricao: 'Cancelada'}
      ],
      listaSituacaoAtividadeCumprida: [
        {item: 3, descricao: 'Cumprida'}
      ],
      listaSituacaoAtividadeCancelada: [
        {item: 4, descricao: 'Cancelada'}
      ],
      obrigatorio: [
        (input) => !!input || 'Este campo é obrigatório'
      ],
      assuntoSummaryRules: [
        (input) => !!input || 'Este campo é obrigatório',
        (input) => !!input && input.length <= 200 || 'Este campo não pode possuir mais que 200 caracteres'
      ],
      nomeAtividadeRules: [
        (input) => !!input || 'Este campo é obrigatório',
        (input) => !!input && input.length <= 250 || 'Este campo não pode possuir mais que 250 caracteres'
      ],
      resultadosRules: [
        (input) => !!input || 'Este campo é obrigatório',
        (input) => !!input && input.length <= 1000 || 'Este campo não pode possuir mais que 1000 caracteres'
      ]
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      cancelar: function () {
        this.$router.push({name: 'AtividadesProjeto', params: {idProjeto: this.idProjeto}})
      },
      editarAtividade: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando atividade.' })
        // Não iniciada ou cancelada
        if (this.atividade.situacaoAtividade !== null && (this.atividade.situacaoAtividade.item === 1 || this.atividade.situacaoAtividade.item === 4)) {
          this.atividade.dtInicioEfetivo = null
          this.atividade.dtFimEfetivo = null
          this.atividade.resultados = null
        }
        // Em andamento
        if (this.atividade.situacaoAtividade !== null && this.atividade.situacaoAtividade.item === 2) {
          this.atividade.dtFimEfetivo = null
        }
        projetos.putAtividade(this.idProjeto, this.idAtividade, this.atividade)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.push({name: 'AtividadesProjeto', params: {idProjeto: this.idProjeto}})
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando atividade.' })
        })
      }
    },
    mounted () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações.' })
      projetos.getExtensaoDoProjeto(this.idProjeto)
      .then(response => {
        this.extensao = response.data
        let aux = this.extensao.objetivosEspecificos.split(';;')
        for (let item in aux) {
          this.objetivosEspecificosTopicos.push({id: item, nome: aux[item]})
        }
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações.' })
      })

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando atividade.' })
      projetos.getAtividade(this.idProjeto, this.idAtividade)
      .then(response => {
        this.atividade = response.data
        // Não iniciada
        if (this.atividade.situacaoAtividade !== null && this.atividade.situacaoAtividade.item === 1) {
          this.listaSituacaoAtividade = this.listaSituacaoAtividadeNaoIniciada
        }
        // Em andamento
        if (this.atividade.situacaoAtividade !== null && this.atividade.situacaoAtividade.item === 2) {
          this.listaSituacaoAtividade = this.listaSituacaoAtividadeEmAndamento
        }
        // Cumprida
        if (this.atividade.situacaoAtividade !== null && this.atividade.situacaoAtividade.item === 3) {
          this.listaSituacaoAtividade = this.listaSituacaoAtividadeCumprida
        }
        // Cancelada
        if (this.atividade.situacaoAtividade !== null && this.atividade.situacaoAtividade.item === 4) {
          this.listaSituacaoAtividade = this.listaSituacaoAtividadeCancelada
        }
        // Situação da atividade não preenchida
        if (this.atividade.situacaoAtividade === null) {
          this.listaSituacaoAtividade = this.listaSituacaoAtividadeNaoPreenchida
        }
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando atividade.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-date-menu': DataMenu,
      'c-date-dialog': DataDialog,
      'c-textarea': TextArea
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// editar-atividade.vue?4a8af65a